const getGroupColors = (theme, colorGroup) => {
  return theme.palette[colorGroup];
};
export {
  getGroupColors
};
